/* -------- Hide Submenu catagory in the header when we brose PLP Page --------- */
document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.pathname;

  document.querySelectorAll('li').forEach(function (li) {
    const submenu = li.querySelector('.sub-menu-block');
    const caret = li.querySelector('.dt-sc-caret');

    if (url.includes('/collections/') && !url.includes('/collections/epicerie') && !url.includes('/products/')) {
      // hidde submenu chevron
      if (submenu) submenu.style.display = 'none';
      if (caret) caret.style.display = 'none';
    }
    if (url.includes('/collections/') && !url.includes('/collections/epicerie')) {
      if (submenu && submenu.querySelector('.active')) {
        li.classList.add('active');
      }
    }
  });
});


/* -------- Toggle the results reviews on PDP Page --------- */
$(document).ready(function () {
  function initReviewToggle() {
    const $reviewCards = $('.AirReviews-Blocks__ListReview .AirReviews-Card.AirReviews-Blocks__ReviewDetails.AirReviews-Card--fat');
    const $toggleBtn = $('<button class="toggle-reviews-btn">').html('Tous les témoignages &rsaquo;');
    
    if ($reviewCards.length === 0) return;
    
    $reviewCards.hide();
    $reviewCards.first().show();
    $('.AirReviews-Blocks__ListSort').prepend($toggleBtn);
    
    $toggleBtn.on('click', function () {
      $reviewCards.show();
      $toggleBtn.remove();
    });
  }

  // Init on loading
  const initialLoad = setInterval(() => {
    if ($('.AirReviews-Blocks__ListReview .AirReviews-Card').length > 0) {
      clearInterval(initialLoad);
      initReviewToggle();
    }
  }, 300);

});


/* -------- Add title & subTitle for WishList Page --------- */
$(document).ready(function () {
  const $wishlistPage = $('#wishlist');
  if ($wishlistPage.length) {
    const $container = $wishlistPage.find('#container');
    const $titleBlock = $(`
      <div class="wishlist-header">
        <h4 class="wishlist-title">Prêts à Être Commandés à Tout Moment</h6>
        <h6 class="wishlist-subtitle">VOS PRODUITS PRÉFÉRÉS</h4>
      </div>
    `);

    $container.prepend($titleBlock);
  }
});


/* --------- Open the drawer cart when product added --------- */
/*$(document).ready(function () {
  const $atcButton = $('button[name="add"]');
  const $cartDrawer = $('#CartDrawer');

  console.log('atcButton :', $atcButton.get(0));
  console.log('cartDrawer :', $cartDrawer.get(0));

  if ($atcButton.length && $cartDrawer.length) {
    $atcButton.on('click', function (e) {
      e.preventDefault();
      console.log('e :', e);
      
      if (!$cartDrawer.hasClass('is-transitioning')) {
        console.log('if:', 'TRRRRRRUE');
        $cartDrawer.addClass('is-transitioning');
      }
    });
  }
});*/





/****************** PDP Swatch Weight ****************/
$(document).ready(function () {
    const $swatchGroup = $('.swatch-group');
    const $poidsLabel = $('.product-label.not_color-swatch-title');

    // Créer un <span> pour afficher la valeur sélectionnée
    const $valueSpan = $('<span>').css({
      'margin-left': '8px',
      'font-weight': 'normal',
      'font-size': '14px'
    });
    $poidsLabel.append($valueSpan);

    function updateValue(value) {
      $valueSpan.text(value);
    }

    // Fonction pour gérer l'ajout de la classe 'active'
    function setActive($input) {
      $('.swatch-element').removeClass('active');
      $input.closest('.swatch-element').addClass('active');
    }

    // Initialisation avec la valeur cochée
    const $checked = $swatchGroup.find('input[type="radio"]:checked');
    if ($checked.length) {
      updateValue($checked.val());
      setActive($checked);
    }

    // Gérer le clic (changement) sur un input radio
    $swatchGroup.find('input[type="radio"]').on('change', function () {
      updateValue($(this).val());
      setActive($(this));
    });

    // Gérer le hover sur les labels
    $swatchGroup.find('label').on('mouseenter', function () {
      const id = $(this).attr('for');
      const value = $('#' + id).val();
      updateValue(value);
    }).on('mouseleave', function () {
      const $checked = $swatchGroup.find('input[type="radio"]:checked');
      if ($checked.length) {
        updateValue($checked.val());
      } else {
        $valueSpan.text('');
      }
    });
});


/**************** PDP accordion ******************/
$(document).ready(function () {
  const headers = document.querySelectorAll('.accordion-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const accordion = item.parentElement;
      accordion.querySelectorAll('.accordion-item').forEach(i => {
        if (i !== item) {
          i.classList.remove('active');
        }
      });
      item.classList.toggle('active');
    });
  });
});